import { Drawer } from 'antd';
import type { DrawerProps } from 'antd';

export interface DDrawerProps extends DrawerProps {}

export const DarwinDrawer = (props: DDrawerProps) => {
  return <Drawer {...props} />;
};
